import React from "react";
import Layout from "../layout/Layout";
import SeoPage from "../components/seo/seo";

const Seo = () => {
  return (
    <>
      <Layout>
        <SeoPage />
      </Layout>
    </>
  );
};

export default Seo;
